import { Box, Flex } from "rebass";
import { getLocalizedString, theme } from "../../utils";
import { FaLongArrowAltDown, FaLongArrowAltUp } from "react-icons/fa";
import useResponsive from "../../hooks/useResponsive";
import { PreLoader } from "../loader/PreLoader";

const CatalogueNavigation = ({
  onLoadMore,
  onGoToTop,
  catalogue,
  currentPage,
  totalPages,
  nextPageInLoading,
  sx,
  ...props
}) => {
  const { isMobile } = useResponsive();

  return (
    <>
      <Flex
        justifyContent={"space-between"}
        sx={{
          ...sx,
        }}
        {...props}
      >
        <Box>
          {catalogue?.length > 0 &&
            currentPage + 1 <= totalPages &&
            !nextPageInLoading && (
              <CatalogueNavigationButton
                icon={<FaLongArrowAltDown />}
                label={getLocalizedString(
                  isMobile
                    ? "CATALOGUE_LOAD_MORE_DRAG_CTA"
                    : "CATALOGUE_LOAD_MORE_CLICK_CTA",
                )}
                onClick={onLoadMore}
              />
            )}
        </Box>
        <Box>
          {catalogue?.length > 0 && !nextPageInLoading && (
            <CatalogueNavigationButton
              icon={<FaLongArrowAltUp />}
              label={getLocalizedString("CATALOGUE_BACK_TO_TOP_CTA")}
              reverse
              onClick={onGoToTop}
            />
          )}
        </Box>
      </Flex>
      {nextPageInLoading && (
        <Flex
          justifyContent={"center"}
          alignContent={"center"}
          sx={{ width: "100%", py: "20px" }}
        >
          <PreLoader color="black" size="sm" />
        </Flex>
      )}
    </>
  );
};

const CatalogueNavigationButton = ({
  icon,
  label,
  reverse = false,
  sx,
  ...props
}) => (
  <Box
    as="button"
    sx={{
      cursor: "pointer",
      padding: "8px",
      "&:hover": {
        backgroundColor: theme.backgroundSecondary,
      },
      ...sx,
    }}
    {...props}
  >
    <Flex
      flexDirection={reverse ? "row-reverse" : "row"}
      alignItems={"center"}
      sx={{ gap: "5px" }}
    >
      <Flex
        width={"24px"}
        height={"24px"}
        padding={"2px"}
        backgroundColor={theme.background}
        color="#fff"
        alignItems={"center"}
        justifyContent={"center"}
      >
        {icon}
      </Flex>
      <Box fontSize={[".8em", "1em"]}>{label}</Box>
    </Flex>
  </Box>
);

export default CatalogueNavigation;
